var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lookMe",on:{"click":_vm.followMe}},[_c('img',{attrs:{"src":require("../../assets/map.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }